export default __webpack_public_path__ + "90bc8046dbfec985088f206fa60d6b1c.png";